import lodash from "lodash";
import { defineAsyncComponent } from "vue";
import { createFieldInput, createFieldSelect } from "../../../../../components/input/template-builder/template-builder.logic";
import { createColumnInput, createColumnSelect } from "../../../../../components/table/c-table.logic";
import i18n from "../../../../../i18n";
import store from "../../../../../store";
import { conditionFormChecker, putField } from "../../../../../utils/form";

const Address = defineAsyncComponent(() => import("../../../../../components/address/Address"));

export const callDepartment = ({ searchQuery }) => store.dispatch("resource/v1/master/department/cacheFindAll", { searchQuery });
export const callDepartmentType = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "DEPARTMENT_TYPE", value: searchQuery });

export const createColumns = () => {
    const columns = [
        createColumnSelect({
            title: () => i18n.global.t("model.department.refParent"),
            dataIndex: "refParent.id",
            customRender: ({ record }) => <div>{record.refParent?.nameTh}</div>,
            inputProp: () => ({ list: callDepartment })
        }),
        createColumnInput({ title: () => i18n.global.t("model.department.nameTh"), dataIndex: "nameTh" }),
        createColumnInput({ title: () => i18n.global.t("model.department.nameEn"), dataIndex: "nameEn" }),
        createColumnSelect({
            title: () => i18n.global.t("model.department.refDepartmentType"),
            dataIndex: "refDepartmentType.id",
            customRender: ({ record }) => <div>{record.refDepartmentType?.value}</div>,
            inputProp: () => ({ list: callDepartmentType })
        })
    ];
    return columns;
};

export const createField = ({ props, data, key, isLoading }) => {
    const { viewOnly, menuContext } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}nameTh`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 18 }}),
                label: () => i18n.global.t("model.department.nameTh"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        { value: model.nameTh, "onUpdate:value": value => (model.nameTh = value), disabled: viewOnly },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}nameEn`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 18 }}),
                label: () => i18n.global.t("model.department.nameEn"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        { value: model.nameEn, "onUpdate:value": value => (model.nameEn = value), disabled: viewOnly },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refDepartmentType`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 18 }}),
                label: () => i18n.global.t("model.department.refDepartmentType"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refDepartmentType,
                            "onUpdate:value": value => (model.refDepartmentType = value),
                            disabled: viewOnly,
                            list: callDepartmentType,
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            // createFieldTextArea({
            //     visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
            //     key: `${prefix}attributeStr`,
            //     colProp: () => ({ xs: 24 }),
            //     formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 18 }}),
            //     label: () => i18n.global.t("model.department.attribute"),
            //     inputProp: ({ field }) => {
            //         const onBlur = () => {
            //             try {
            //                 model.attribute = JSON.parse(model.attributeStr);
            //                 model.attributeStr = JSON.stringify(model.attribute, null, 4);
            //             } catch (error) {
            //                 error;
            //             }
            //             useForm.validate("attributeStr").catch(() => {});
            //         };
            //         return lodash.merge(
            //             {
            //                 value: model.attributeStr,
            //                 "onUpdate:value": value => (model.attributeStr = value),
            //                 rows: 6,
            //                 onBlur,
            //                 disabled: viewOnly
            //             },
            //             conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
            //         );
            //     }
            // }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 18 }}),
                label: () => i18n.global.t("model.address.modelName"),
                inputRender: () => (
                    <Address
                        menuContext={menuContext}
                        viewOnly={viewOnly}
                        dataProp={data}
                        dataKey={`${prefix}addresses.0`}
                        isLoading={isLoading.value}
                    ></Address>
                )
            },
            {
                key: `${prefix}addresses`,
                label: () => i18n.global.t("model.address.modelName"),
                changeLog: { getValueChildren: ({ record }) => record.addrTh }
            }
        ]
    });
};
